import * as React from 'react';
import { useSlate } from 'slate-react';
import { NodeEntry } from 'slate/dist/interfaces/node';

import { getNode } from '../../../../slatePlugins/common/queries/getNode';

interface ItemToolbarContextValue {
  isToolbarFocus: boolean;
  selectedItem: NodeEntry;
  setSelectedItem: React.Dispatch<React.SetStateAction<NodeEntry>>;
}

export const ItemToolbarContext = React.createContext<ItemToolbarContextValue>(null);

export const useItemContextToolbar = () => {
  const editor = useSlate();
  const { selectedItem: item, setSelectedItem } = React.useContext(ItemToolbarContext);

  // track changes applied to editor
  let selectedItem = item;
  if (item) {
    const foundItem = getNode(editor, item[1]);
    if (!foundItem) {
      setSelectedItem(null);
      selectedItem = null;
    } else {
      selectedItem[0] = foundItem;
    }
  }

  return { selectedItem, setSelectedItem };
};
